import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import React, { useEffect, useRef } from 'react';

const Composer = ({
   draft,
   onDraftChange,
   onSend,
   disabled,
   readOnly,
   readOnlyMessage,
   renderMediaActions,
   pendingMedia
}) => {
   const textareaRef = useRef(null);

   useEffect(() => {
      const textarea = textareaRef.current;
      if (!textarea) return;
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 160)}px`;
   }, [draft]);

   if (readOnly) {
      return <div className='chatterbox-readonly'>{readOnlyMessage || 'This conversation is read-only.'}</div>;
   }

   const canSend = !disabled && Boolean((draft || '').trim());

   return (
      <div className='chatterbox-composer'>
         <div className='chatterbox-composer-actions'>
            {renderMediaActions ? renderMediaActions({ disabled, pendingMedia }) : null}
         </div>
         <textarea
            ref={textareaRef}
            rows={1}
            value={draft || ''}
            onChange={(event) => onDraftChange(event.target.value)}
            placeholder='Add a note…'
            aria-label='Add a note'
            disabled={disabled}
         />
         <IconButton
            className='chatterbox-send'
            color='primary'
            aria-label='Send note'
            disabled={!canSend}
            onClick={onSend}
         >
            <SendIcon />
         </IconButton>
      </div>
   );
};

export default Composer;
